var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-time-answer gray-dark-900"},[_c('h4',{staticClass:"heading-h4"},[_vm._v(_vm._s(_vm.nameline))]),_c('p',{staticClass:"display-1 font-bold title-time"},[_vm._v(_vm._s(_vm.time)+" minutos")]),_c('p',{staticClass:"body-4 gray-dark-800 mrg-bottom-0"},[_vm._v("Promedio")])])
}
var staticRenderFns = []

export { render, staticRenderFns }